export default [
	{
		titulo: 'Classificação SEMED',
		icone: 'menu-icon fa fa-caret-right',
		url: '/servicos/classificacao-semed',
		visualizar: false,
		actions: [
			{
				value: false,
				name: 'Cadastrar',
			},
			{
				value: false,
				name: 'Editar',
			},
			{
				value: false,
				name: 'Apagar',
			},
		],
	},
]
